module.exports = __webpack_public_path__ + "img/19-green.d399b019.svg";